import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import Header from './components/header';
import Details from './components/details';
import CareGiverDetails from './components/caregiverDetails';
import OtherInfo from './components/otherInfo';
import { ProgramRegistrationAPI } from '../../../API/API-programRegistration';
import { membershipAPI } from '../../../API/API-membership';
import { FamilyAPI } from '../../../API/API-familyMembers';

class RegistrationDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notFound: false,
    };
  }

  componentDidMount() {
    const { programID, membershipID, familyMemberID } = this.props.match.params;
    ProgramRegistrationAPI.GET.getProgramRegistrationDetails(programID, membershipID)
      .then((success) => {
        let updateData;
        console.log(success.data);
        for (let i = 0; i < success.data.length; i++) {
          for (let s = 0; s < success.data[i].medicalInformation[0].length; s++) {
            if (familyMemberID === success.data[i].medicalInformation[0][s]._id) {
              updateData = success.data[i];
            }
          }
        }
        if (!updateData) {
          this.setState({ notFound: true });
          return;
        }
        membershipAPI.GET.getMembershipByID(membershipID)
          .then((membershipResonse) => {
            if (!membershipResonse.data || !membershipResonse.data.membership || !membershipResonse.data.primaryMember) {
              this.setState({ notFound: true });
              return;
            }
            updateData.membership = membershipResonse.data;
            FamilyAPI.GET.getFamilyMemberByID(familyMemberID)
              .then((familyMemberResponse) => {
                if (!familyMemberResponse.data || !familyMemberResponse.data[0]) {
                  this.setState({ notFound: true });
                  return;
                }
                updateData.participantData = familyMemberResponse.data[0];
                let participantMedicalInformation = {};
                for (let i = 0; i < updateData.medicalInformation.length; i++) {
                  if (updateData.medicalInformation[i][0]._id === familyMemberID) {
                    participantMedicalInformation = updateData.medicalInformation[i][0];
                  }
                }
                updateData.participantMedicalInformation = participantMedicalInformation;
                this.setState({ data: updateData });
              })
              .catch((errors) => {
                console.log(errors);
                this.setState({ notFound: true });
              });
          })
          .catch((err) => {
            console.log(err);
            this.setState({ notFound: true });
          });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ notFound: true });
      });
  }

  render() {
    const { data, notFound } = this.state;
    const { match, history } = this.props;
    if (notFound) {
      return (
        <Grid item xs className="font-family-default">
          <Grid container className="font-family-default">
            <Grid item xs style={{ margin: '20px' }}>
              <Grid
                className="Back-to-Member-list"
                onClick={() => history.push(`/adminPortal/programs/registrationList/${match.params.programID}`)}
                onKeyPress={() => history.push(`/adminPortal/programs/registrationList/${match.params.programID}`)}
                role="button"
                tabIndex={0}
              >
                &lt;  Back to Registrations List
              </Grid>
              <Grid className="verify-member-title">
                Program Participant Detail
              </Grid>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs className="programDetails-spacing">
              <Grid className="programDetails-boxes">
                <Grid className="programDetails-boxes-main-title">
                  Participant not found
                </Grid>
                <Grid className="programDetails-boxes-text">
                  This participant may have been deleted from the database or is no longer linked to this registration.
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    }
    return (
      <>
        <Grid item xs className="font-family-default">
          <Header data={data} history={history} match={match} />
          <Details data={data} history={history} match={match} />
          <CareGiverDetails data={data} history={history} match={match} />
          <OtherInfo data={data} history={history} match={match} />
        </Grid>
      </>
    );
  }
}

RegistrationDetails.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      programID: PropTypes.string,
      membershipID: PropTypes.string,
      familyMemberID: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  userData: PropTypes.shape({
    userType: PropTypes.string,
  }),
};

export default RegistrationDetails;
